import {
    generateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost,
    getGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGet,
    getProductGenerationsApiV1GenerationsOrgIdProductProductIdGet,
} from '@/common/api/client/sdk.gen'
import type {
    BodyGenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost,
    GenerateTitleDetailResponse,
    GenerationCreateResponse,
    PageGenerationListResponse,
} from '@/common/api/client/types.gen'
import { useProductFlow, type ProductFlowState } from './productFlow'

const TEXTS_FLOW_KEY = 'texts-generate-title'

export const fetchTextsGenerationList = async ({
    orgId,
    productId,
    page,
    pageSize,
}: {
    orgId: string
    productId: string
    page: number
    pageSize: number
}): Promise<PageGenerationListResponse> => {
    const res = await getProductGenerationsApiV1GenerationsOrgIdProductProductIdGet({
        path: { org_id: orgId, product_id: productId },
        query: {
            generation_type: 'text_seo',
            order_by: 'created_at',
            direction: 'desc',
            page,
            size: pageSize,
        },
    })
    return res.data!
}

export const useProductTextsGeneration = (): ProductFlowState<
    PageGenerationListResponse,
    GenerateTitleDetailResponse,
    BodyGenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost,
    GenerationCreateResponse
> => {
    return useProductFlow<
        PageGenerationListResponse,
        GenerateTitleDetailResponse,
        BodyGenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost,
        GenerationCreateResponse
    >({
        flowKey: TEXTS_FLOW_KEY,
        fetchList: ({ orgId, productId, page, pageSize }) =>
            fetchTextsGenerationList({ orgId, productId, page, pageSize }),
        selectIdFromList: list => list?.items[0]?.id ?? null,
        extractIdFromMutationResult: r => r.generation_id,
        fetchDetail: async (orgId, generationId) => {
            const res = await getGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGet({
                path: { org_id: orgId, generation_id: generationId },
            })
            return res.data!
        },
        runMutation: async ({ orgId, productId, variables }) => {
            const res = await generateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost({
                path: { org_id: orgId, product_id: productId },
                body: variables ?? {},
            })
            return res.data!
        },
    })
}

export type ProductTextsGenerationState = ProductFlowState<
    PageGenerationListResponse,
    GenerateTitleDetailResponse,
    BodyGenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost,
    GenerationCreateResponse
>
